const integrations = {
  metadata: {
    required: "Fill in the required fields before connecting this tool.",
    tab: "Metadata",
    valuePlaceholder: "value",
  },
  models: {
    problem: {
      emptyName: "There is a model without a name.",
      duplicate: "{{model}}: duplicate name.",
      missingApi: "{{model}}: choose the route.",
      missingDimensions: "{{model}}: enter the dimensions (vector size).",
      invalidDimensions: "{{model}}: dimensions must be a positive whole number.",
    },
    empty: "No models registered.",
    add: "Add model",
    remove: "Remove model",
    namePlaceholder: "model or deployment name",
    apiPlaceholder: "route",
    apiVersionPlaceholder: "api-version",
    apiVersionSuspect:
      "This value does not look like the date format providers use for api-version. Double-check it before saving.",
    apiVersionHint:
      "The api-version is the provider's REST API version, not the model version shown in its portal. It applies to this model only: different routes on the same resource may require different versions.",
    dimensionsPlaceholder: "dimensions",
    serves: "serves the model {{model}}",
    invalid: "Review the models: each one needs a name and a route, and indexing models need the dimensions.",
  },
  title: "Tools",
  description: "Integrate all your tools in one place",
  empty: {
    title: "No tools found",
    description: "Configure a new tool to get started"
  },
  new: {
    title: "New Tool",
    description: "Configure a new tool"
  },
  form: {
    name: "Name",
    description: "Description",
    type: "Type",
    status: "Status",
    authType: "Authentication Type",
    selectAuthType: "Select an authentication type",
    title: {
      label: "Tool Name",
      placeholder: "Ex: Jira for Mobile Squad",
      required: "Tool name is required"
    },
    errors: {
      requiredFields: "Required fields not filled: {{fields}}",
      create: "Error creating tool. Check the data and try again.",
      update: "Error updating tool. Check the data and try again.",
      unknown: "Unknown error"
    },
    defaultDescription: "Tool configured via Prodgy"
  },
  status: {
    active: "Active",
    inactive: "Inactive",
    pending: "Pending",
    failed: "Failed",
    connected: "Connected",
    disconnected: "Disconnected",
    syncing: "Syncing",
    synced: "Synced",
    unknown: "Unknown"
  },
  fields: {
    apiKey: "API Key",
    model: "Model",
    clientId: "Client ID",
    clientSecret: "Client Secret",
    accessToken: "Access Token",
    redirectUri: "Redirect URI",
    privateToken: "Private Token",
    gitlabUrl: "GitLab URL",
    gitlabProjectId: "GitLab Project ID",
    organization: "Organization",
    googleProjectId: "Google Project ID",
    username: "Username",
    password: "Password",
    scope: "Scope",
    apiKeyPlaceholder: "Enter your OpenRouter API key",
    modelPlaceholder: "Enter model name (e.g. openai/gpt-4)",
    clientIdPlaceholder: "Enter Client ID",
    clientSecretPlaceholder: "Enter Client Secret",
    accessTokenPlaceholder: "Enter Access Token",
    redirectUriPlaceholder: "Enter Redirect URI",
    privateTokenPlaceholder: "Enter Private Token",
    gitlabUrlPlaceholder: "Enter GitLab URL",
    gitlabProjectIdPlaceholder: "Enter GitLab Project ID",
    organizationPlaceholder: "Enter Organization name",
    googleProjectIdPlaceholder: "Enter Google Project ID",
    usernamePlaceholder: "Enter username",
    passwordPlaceholder: "Enter password",
    scopePlaceholder: "Enter scope"
  },
  actions: {
    connect: "Connect",
    disconnect: "Disconnect",
    save: "Save changes",
    cancel: "Cancel",
    test: "Test connection",
    sync: "Sync",
    update: "Update",
    connecting: "Connecting...",
    updating: "Updating...",
    remove: "Remove",
    configure: "Configure"
  },
  messages: {
    connected: "Tool connected successfully",
    disconnected: "Tool disconnected successfully",
    saved: "Changes saved successfully",
    error: "Error processing operation",
    authUpdated: "Authentication settings updated successfully",
    authUpdateError: "Failed to update authentication settings",
    connectionTestFailed: "Connection test failed. Please check your credentials and try again.",
    cannotDelete: "Cannot remove tool",
    deleteSuccess: "was removed successfully!",
    deleteError: "Error removing tool. Please try again.",
    hasDependencies: "This tool is being used by {{dependencies}}. Remove these dependencies before deleting the tool."
  },
  searchPlaceholder: "Search tools...",
  searchTools: "Search tools...",
  addIntegration: "Add Tool",
  add: "Add",
  encrypted: "Encrypted",
  configure: "Configure",
  lastValidated: "Last validated",
  selectTemplate: "Select the tool you want to integrate with Prodgy",
  select: "Select",
  sections: {
    settings: "Settings",
    authentication: "Authentication"
  },
  placeholders: {
    select: "Select...",
    enterField: "Enter {{field}}"
  },
  defaultFields: {
    integrationName: "Tool Name",
    integrationNamePlaceholder: "Enter a name for this tool",
    apiKeyToken: "API Key/Token"
  },
  editDialog: {
    edit: "Edit",
    editTitle: "Edit {{name}}",
    updateSettings: "Update the tool settings and credentials",
    configureIntegration: "Configure the tool"
  },
  scope: {
    label: "Scope",
    addTo: "Add the tool to...",
    workspaceOnly: "Workspace only",
    globalAll: "Whole organization",
    sectionWorkspace: "From the workspace",
    sectionOrganization: "From the whole organization",
    missingOrg: "Could not identify the current organization.",
    missingWorkspace: "Select a workspace or mark the tool as global.",
    permissionsLabel: "Permissions",
    productLabel: "Product",
    organizationLabel: "Organization",
    organizationHint: "This tool will be available for use in all products of the organization.",
    productHint: "This tool will be restricted to the current product and will override the organization version, if it exists.",
    product: "This product",
    general: "Global"
  },
  postInstall: {
    title: "Tool created — next steps",
    subtitle: "Configure {{name}} using the values below and follow the instructions to complete installation.",
    copied: "URL copied",
    copyFailed: "Failed to copy",
    copy: "Copy",
    instructionsLabel: "Setup instructions",
    confirm: "Got it",
    manifestLabel: "App Manifest",
    copyManifest: "Copy JSON",
    downloadZip: "Download ZIP",
    zipBuilding: "Building...",
    zipFailed: "Failed to build the ZIP package"
  },
  delete: {
    title: "Remove Tool",
    confirmMessage: "Are you sure you want to remove the tool <strong>{{name}}</strong>?",
    warning: "This action cannot be undone. All settings and credentials will be permanently lost.",
    removing: "Removing...",
    confirm: "Yes, Remove"
  },
  selector: {
    noIntegrations: "No tools",
    noToolsFound: "No tools found",
    resultCount_one: "{{count}} tool",
    resultCount_other: "{{count}} tools",
    filtered_one: "filtered",
    filtered_other: "filtered",
    forQuery: "for \"{{query}}\"",
    requiredNotInstalled: "The tool required by the flow is not installed",
    addNewPrompt: "Or add a new tool...",
    addFirstPrompt: "Add a tool to get started...",
    templateDescription: "Tool template"
  }
} as const;

export default integrations;
